import { useRouter } from 'found';
import React, { useState } from 'react';
import { makeMutation } from '../../../../api/helpers';
import { AddAccount } from '../../../../api/mutations';
import ContentCenterer from '../../../../components/ContentCenterer';
import Button from '../../../../components/input/Button';
import TextInput from '../../../../components/input/TextInput';
import Spacer from '../../../../components/Spacer';
import {
  NormalText,
  PageTitle,
} from '../../../../components/typography/Typography';
import { Buttons } from '../Buttons';
import { useToastDispatch } from '../../../../components/Toast/ToastProvider';
import { mutationsAddAccountMutationVariables } from '../../../../api/__generated__/mutationsAddAccountMutation.graphql';
import styled from 'styled-components';
import { setCurrentAccount } from '../../../../account_helpers';
import { routes } from '../../../../routes';

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
`;

function CreateAccount() {
  const [formState, setFormState] = useState({
    name: '',
  });
  const { router } = useRouter();
  const dispatch = useToastDispatch();

  // onClose go back to previous page
  const onClose = () => {
    router.go(-1);
  };

  const onSave = async () => {
    if (formState.name.replace(' ', '') === '') {
      dispatch({ text: 'Please enter an account name', alert: 'error' });
      return;
    }
    const variables: mutationsAddAccountMutationVariables = {
      name: formState.name,
    };

    try {
      const resp = await makeMutation(AddAccount, variables);
      dispatch({
        text: `'${formState.name}' account created successfully`,
        alert: 'success',
      });
      setCurrentAccount(resp.addAccount.id);
      router.push(routes.subscriptions);
    } catch (err) {
      dispatch({ text: err.toString(), alert: 'error', stayFor: 4000 });
    }
  };

  return (
    <Container>
      <ContentCenterer maxWidth={'838px'}>
        <Spacer spacing={4} vertical />
        <PageTitle>Create a new team</PageTitle>
        <Spacer vertical spacing={2} />
        <NormalText>
          A team allows you to both subscribe to and create your own APIs and
          invite others to collaborate. All APIs, keys, settings etc are
          separate between teams.
        </NormalText>
        <Spacer vertical spacing={4} />
        <TextInput
          label={'TEAM NAME'}
          placeholder={'Team name'}
          value={formState.name}
          onChange={(text) => setFormState((val) => ({ ...val, name: text }))}
        />
        <Spacer vertical spacing={4} />
        <Buttons>
          <Button background={'#bab8c5'} color={'white'} onClick={onClose}>
            Cancel
          </Button>
          <Button color={'white'} onClick={onSave}>
            Save
          </Button>
        </Buttons>
      </ContentCenterer>
    </Container>
  );
}

export default CreateAccount;
